export const EVALUATION_SETTING_KEYS = [
  'ai_detection_plans_id',
  'evaluation_rep_note_enabled',
  'evaluation_rep_note_label',
  'evaluation_rep_note_label_l10n',
];

export function pickEvaluationSettings(source) {
  const settings = {};
  EVALUATION_SETTING_KEYS.filter(key => source && key in source).forEach(key => {
    settings[key] = source[key];
  });
  return settings;
}

// An untranslated label serves its *_l10n as [], and English falls back to the single-language label.
function labelEntries(settings) {
  const l10n = settings.evaluation_rep_note_label_l10n;
  const labels = l10n && !Array.isArray(l10n) ? { ...l10n } : {};
  if (!labels.en_US && settings.evaluation_rep_note_label) {
    labels.en_US = settings.evaluation_rep_note_label;
  }
  return Object.keys(labels)
    .filter(locale => String(labels[locale] || '').trim() !== '')
    .sort()
    .map(locale => [locale, String(labels[locale]).trim()]);
}

function comparable(key, settings) {
  const value = settings[key];
  if (key === 'ai_detection_plans_id') {
    return value === null || value === undefined || value === '' ? '' : String(value);
  }
  if (key === 'evaluation_rep_note_enabled') {
    return value === true || ['t', 'true', '1'].includes(String(value).toLowerCase());
  }
  return String(value || '').trim();
}

// Translations are diffed per locale, since another admin may have changed a different one.
function changedLabels(current, loaded) {
  const before = Object.fromEntries(labelEntries(loaded));
  const after = Object.fromEntries(labelEntries(current));
  const changed = {};
  Object.keys({ ...before, ...after })
    .filter(locale => (before[locale] || '') !== (after[locale] || ''))
    .forEach(locale => {
      changed[locale] = after[locale] || '';
    });
  return changed;
}

// Only what an admin changed is posted: the server leaves an absent key alone, so a stale builder
// cannot put back a value another admin has since changed.
export function changedEvaluationSettings(current, loaded) {
  const changed = {};
  EVALUATION_SETTING_KEYS.filter(key => key in current).forEach(key => {
    if (key === 'evaluation_rep_note_label_l10n') {
      const labels = changedLabels(current, loaded);
      if (Object.keys(labels).length) {
        changed[key] = labels;
      }
    } else if (comparable(key, current) !== comparable(key, loaded)) {
      changed[key] = current[key];
    }
  });
  return changed;
}

// A label saved before a second language was enabled has no translation row yet.
export function repNoteLabelsFor(field, defaultLocale) {
  const l10n = field.evaluation_rep_note_label_l10n;
  const labels = l10n && !Array.isArray(l10n) ? { ...l10n } : {};
  if (!labels[defaultLocale] && field.evaluation_rep_note_label) {
    labels[defaultLocale] = field.evaluation_rep_note_label;
  }
  return labels;
}
